import { createStateClass } from '../stateClass.js';
const [stateClass] = createStateClass("textfield");
export { stateClass };
